import cx from "classnames";
import React from "react";

const CLASS_ROOT = "skeleton";

const Skeleton: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({
  className,
  ...other
}) => {
  const classes = cx(CLASS_ROOT, className);

  return (
    <span className={classes} {...other}>
      &zwnj;
    </span>
  );
};

Skeleton.displayName = "Skeleton";

export { Skeleton };
